<template>
  <section>
    <template v-if="contractId > 4853">
      <aRow>
        <aCol
          class="collapse-card"
          v-for="{ id } in bankTransferRows"
          :key="id"
          :span="24"
        >
          <div class="head" @click="onClickOpenCollapse(id)">
            <aRow :gutter="20">
              <aCol class="id cprimary" :span="1">
                <span class="ico">
                  <aIcon type="bank" />
                  <span class="num">{{ id }} </span>
                </span>
              </aCol>

              <aCol class="id-name" :span="11">
                TRANSFERÊNCIA BANCÁRIA ({{
                  tempContract[
                    `payment_methods_bank_transfer_bank_${id}${keySuffix}`
                  ] ?? "BANCO"
                }})
              </aCol>

              <aCol class="value" :span="9">
                <aTag :color="'blue'">
                  {{
                    tempContract[
                      `payment_methods_bank_transfer_total_value_${id}${keySuffix}`
                    ] | formatPricePtBrComma
                  }}
                </aTag>
              </aCol>

              <aCol class="a-right" :span="3">
                <aButton
                  class="ml-5"
                  v-if="id > 1 && bankTransferRows.length === id"
                  size="small"
                  type="danger"
                  shape="circle"
                  icon="delete"
                  @click="removeRow(id - 1)"
                  ghost
                >
                </aButton>
              </aCol>
            </aRow>
          </div>

          <div class="content" v-if="openCollapse === id">
            <BankTransferCollapse
              :form="form"
              :bankTransferId="id"
              :tempContract="tempContract"
              :keyPrefix="keyPrefix"
              :keySuffix="keySuffix"
              :reservation_total_price="reservation_total_price"
              @updateBankTransferValue="updateBankTransferValue"
            />
          </div>
        </aCol>
      </aRow>

      <div class="a-center mb-40 mt-20">
        <aButton
          type="primary"
          @click="addNewRow(bankTransferRows.length)"
          ghost
        >
          Adicionar transferência bancária
        </aButton>

        <aFormItem class="none">
          <aInput v-decorator="[`bank_transfer_rows${keySuffix}`]" />
          <aInput
            v-decorator="[
              `payment_methods_bank_transfer_total_value${keySuffix}`,
            ]"
          />
        </aFormItem>
      </div>
    </template>
  </section>
</template>

<script>
import { parse } from "vue-currency-input";
import formatThings from "@/mixins/general/formatThings.js";
import BankTransferCollapse from "../collapses/BankTransferCollapse.vue";

export default {
  name: "BankTransferTabModal",
  props: {
    tempContract: Object,
    form: Object,
    keyPrefix: String,
    keySuffix: String,
    reservation_total_price: Number,
  },
  components: { BankTransferCollapse },
  mixins: [formatThings],
  data() {
    return {
      openCollapse: "",
      bankTransferRows: [],
      contractId: parseInt(this.tempContract.id),
    };
  },
  mounted() {
    if (
      this.tempContract[`bank_transfer_rows${this.keySuffix}`] !== undefined
    ) {
      this.bankTransferRows = JSON.parse(
        this.tempContract[`bank_transfer_rows${this.keySuffix}`]
      );
    }

    this.form.setFieldsValue({
      [`bank_transfer_rows${this.keySuffix}`]: JSON.stringify(
        this.bankTransferRows
      ),
    });

    this.updateBankTransferValue();
  },
  methods: {
    updateBankTransferValue() {
      let theTotal = 0;
      this.bankTransferRows.forEach((bankTransfer) => {
        theTotal += parse(
          this.tempContract[
            `payment_methods_bank_transfer_total_value_${bankTransfer.id}${this.keySuffix}`
          ]
        );
      });

      this.tempContract[
        `payment_methods_bank_transfer_total_value${this.keySuffix}`
      ] = `${theTotal}`.replace(".", ",");

      this.form.setFieldsValue({
        [`payment_methods_bank_transfer_total_value${this.keySuffix}`]:
          `${theTotal}`.replace(".", ","),
      });

      this.$emit("updateTotalValue");
    },
    onClickOpenCollapse(id) {
      if (id == this.openCollapse) {
        this.openCollapse = 0;
      } else {
        this.openCollapse = id;
      }
    },
    addNewRow(id) {
      this.bankTransferRows.push({
        id: id + 1,
      });

      this.tempContract[`bank_transfer_rows${this.keySuffix}`] = JSON.stringify(
        this.bankTransferRows
      );

      this.form.setFieldsValue({
        [`bank_transfer_rows${this.keySuffix}`]: JSON.stringify(
          this.bankTransferRows
        ),
      });

      this.updateBankTransferValue();
    },
    removeRow(index) {
      for (var i in this.bankTransferRows) {
        if (i == index) {
          this.bankTransferRows.splice(i, 1);
          break;
        }
      }

      this.tempContract[`bank_transfer_rows${this.keySuffix}`] = JSON.stringify(
        this.bankTransferRows
      );

      this.form.setFieldsValue({
        [`bank_transfer_rows${this.keySuffix}`]: JSON.stringify(
          this.bankTransferRows
        ),
      });

      this.updateBankTransferValue();
    },
  },
};
</script>

<style lang="sass" scoped>
.collapse-card
  .content
    padding: 30px 20px 20px
    border: 1px solid #ccc
    margin-top: -14px
    border-radius: 0 0 6px 6px
    margin-bottom: 11px
    background: #fff
  .head
    cursor: pointer
    clear: both
    padding:  20px
    background: #fff
    border: 1px solid #ccc
    margin-bottom: 10px
    border-radius: 6px
    .id
      color: #474747
      font-weight: 600
      .ico
        position: relative
        font-size: 14px
      .num
        position: absolute
        right: -13px
        top: 0
        font-size: 11px
        color: #333
    .id-name
      padding-left: 20px !important
      color: #42413f
      font-weight: 500
      text-transform: uppercase
    .value
      font-size: 10px
      color: #42413f
      font-weight: 500
      text-transform: uppercase
</style>
